module.exports = __webpack_public_path__ + "static/media/gastro.ba5b062d.webp";